import React, { useState } from "react";

const PayElectricityBill = () => {
  const [formData, setFormData] = useState({
    paymentOption: "Wallet",
    electricCompany: "",
    meterType: "",
    meterNo: "",
    phoneNo: "",
    amount: "",
    autoRenew: "0",
  });

  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setLoading(true);

    const {
      electricCompany,
      meterType,
      meterNo,
      amount,
      phoneNo,
    } = formData;

    const apiUrl = `https://www.nellobytesystems.com/APIElectricityV1.asp?UserID=CK123&APIKey=456&ElectricCompany=${electricCompany}&MeterType=${meterType}&MeterNo=${meterNo}&Amount=${amount}&PhoneNo=${phoneNo}&CallBackURL=http://www.your-website.com`;

    try {
      const response = await fetch(apiUrl, { method: "POST" });
      const result = await response.json();
      setMessage("Payment processed successfully!");
      console.log(result);
    } catch (error) {
      console.error("Error processing payment:", error);
      setMessage("Failed to process payment. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-light2 dark:bg-dark1 text-dark0 dark:text-light1 space-y-6 w-full py-4 px-8 rounded-md">
      <div className="flex flex-col justify-center items-start space-y-2">
        <h2 className="text-primary bg-light1 dark:bg-dark2 px-8 py-1 rounded-2xl">
          Pay Electricity Bill
        </h2>
        <hr className="border-dark0 w-full" />
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">

        {/* Electricity Company */}
        <div>
          <label className="block mb-2">Electricity Company:</label>
          <select
            className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
            name="electricCompany"
            value={formData.electricCompany}
            onChange={handleChange}
          >
            <option value="">Select Company</option>
            <option value="01">Eko Electric - EKEDC</option>
            <option value="03">Abuja Electric - AEDC</option>
            <option value="05">Portharcourt Electric - PHEDC</option>
            <option value="07">Ibadan Electric - IBEDC</option>
            <option value="08">Kaduna Electric - KAEDC</option>
            <option value="06">Jos Electric - JEDC</option>
            <option value="09">Enugu Electric - EEDC</option>
            <option value="10">Benin Electric - BEDC</option>
            <option value="11">Yola Electric - YEDC</option>
          </select>
        </div>

        {/* Meter Type */}
        <div>
          <label className="block mb-2">Meter Type:</label>
          <select
            className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
            name="meterType"
            value={formData.meterType}
            onChange={handleChange}
          >
            <option value="">Select Meter Type</option>
            <option value="01">Prepaid</option>
            <option value="02">Postpaid</option>
          </select>
        </div>

        {/* Meter Number */}
        <div>
          <label className="block mb-2">Meter Number:</label>
          <input
            className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
            type="text"
            name="meterNo"
            value={formData.meterNo}
            onChange={handleChange}
          />
        </div>

        {/* Phone Number */}
        <div>
          <label className="block mb-2">Phone Number:</label>
          <input
            className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
            type="text"
            name="phoneNo"
            value={formData.phoneNo}
            onChange={handleChange}
          />
        </div>

        {/* Amount */}
        <div>
          <label className="block mb-2">Amount:</label>
          <input
            className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
            type="text"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="btn w-full"
          disabled={loading}
        >
          {loading ? "Processing..." : "Pay Now"}
        </button>
      </form>
      {message && <p className="mt-4 text-red-500">{message}</p>}
    </div>
  );
};

export default PayElectricityBill;
